module.exports = "<div class=\"modal-archismall\">\n    <div class=\"modal-header\">\n        <h3 class=\"modal-title\">Conferma per eliminare i documenti selezionati</h3>\n    </div>\n    <div class=\"modal-footer\">\n      <a ng-click=\"annulla()\">Annulla</a>\n      <a ng-click=\"ok()\">Ok</a>\n    </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/commons/components/conferma-elimina-doc-conservazione/conferma-elimina-doc-conservazione.html
// module id = 1387
// module chunks = 0